<template>
  <div id='main' v-bind:style='{backgroundColor: color}'>
    <Navbar/>
    <Question/>
  </div>
</template>

<script>
import Question from './components/Question.vue'
import Navbar from './components/Navbar.vue'
export default {
  name: 'Main',
  components: {
    Question,
    Navbar
  },
  data(){
    return {
      color: null
    }
  },
  methods:{
    async register(){
      let response = await fetch(`${process.env.VUE_APP_API}/register`)
      let data = await response.json()
      localStorage.setItem('hash', data.hash)
    }
  },
  mounted(){
    let hash = localStorage.getItem('hash') 
    if(!hash)
      this.register()

    this.$root.$on('color', color => {
      this.color = color
    })
  }
}
</script>

<style>
#main {
  height: 100%;
  margin: 0;
  display: grid;
  grid-template-rows: 50px auto;
}
</style>
